import { getCurrentConfiguration } from "../utils/getCurrentConfiguration";
import { isServerSide } from "../utils/isServerSide";

import type { Config } from "./config.types";

/**
 * @deprecated you should use `useConfig` hook instead from `@jti/ui` package
 * @returns {Config} - returns the current configuration
 */
export const getConfig = (): Config => {
  if (isServerSide()) {
    console.warn("getConfig will not work on server side. Please refactor to use useConfig hook instead.");
    return {} as Config;
  }
  const config = getCurrentConfiguration() as unknown as Config;

  return config;
};

/**
 * @deprecated you should use `useLocale` hook instead from `@jti/ui` package
 * @returns {string} - returns the current locale
 */
export const getLocale = (): string => {
  if (isServerSide()) {
    return "en";
  }
  return window.document.documentElement.lang || "en";
};

export const isCommerceInactive = (): boolean =>
  !!window.document.querySelector(`meta[property="commerce-disabled"],meta[name="commerce-disabled"]`);

export const isFreeTrialActive = (config: Pick<Config, "FREE_TRIAL_FEATURE_FLAG" | "trials-store-view">): boolean =>
  config.FREE_TRIAL_FEATURE_FLAG === "true" && config["trials-store-view"] !== undefined;

export const hasFreeTrialDashboard = (
  config: Pick<
    Config,
    | "FREE_TRIAL_USER_DASHBOARD_SHOW"
    | "DISABLE_USER_DASHBOARD_FREE_TRIAL"
    | "FREE_TRIAL_FEATURE_FLAG"
    | "trials-store-view"
  >
): boolean =>
  (config.FREE_TRIAL_USER_DASHBOARD_SHOW === "true" || !config.DISABLE_USER_DASHBOARD_FREE_TRIAL) &&
  isFreeTrialActive(config);
